import MaximizeIcon from './MaximizeIcon'

export default MaximizeIcon
